import React from 'react';
import { Modal, Typography } from 'antd';
import { t } from '../i18n';

const { Text } = Typography;

// 归属验证 TXT 记录(名称 / 值,可复制)
export function OwnershipTxtRecord({ name, value }) {
    if (!name || !value) return null;
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 12px', alignItems: 'center', minWidth: 0 }}>
            <Text type="secondary">TXT</Text>
            <Text code copyable style={{ wordBreak: 'break-all' }}>{name}</Text>
            <span />
            <Text code copyable style={{ wordBreak: 'break-all' }}>{value}</Text>
        </div>
    );
}

// 接口返回 code=ownership_required(名字被他人未验证占用)→ 弹出 TXT 记录;返回是否已处理
export function showOwnershipRequired(res) {
    const v = res?.code === 'ownership_required' ? res.verify : null;
    if (!v?.txt_name) return false;
    Modal.warning({
        title: t('Verify domain ownership'),
        width: 560,
        content: (
            <div>
                <div style={{ marginBottom: 8 }}>{t('Add this TXT record at your current DNS provider, then try again.')}</div>
                <OwnershipTxtRecord name={v.txt_name} value={v.txt_value} />
            </div>
        ),
    });
    return true;
}
